import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import PoweredBy from 'components/PoweredBy';

interface PublicCTAProps {
    branding?: boolean,
    onboard?: boolean
}

const PublicCTA = ({ branding, onboard }: PublicCTAProps) => {
    const { t } = useTranslation('onboarding');

    return (
        <div className="public-page-overlay">
            {
                onboard ? (
                    <>
                        <Link to="/signup" className="btn btn-small btn-success">{ t('Sign up') }</Link>

                        <Link to="/login" className="btn btn btn-small btn-secondary">{ t('Log in') }</Link>
                    </>
                ) : null
            }

            {
                branding ? <PoweredBy /> : null
            }
        </div>
    );
}

export default PublicCTA;
